import { AlertCircle, CheckCircle, Clock, XCircle } from 'lucide-react'
import React from 'react'

interface RequestStatusIconProps {
    requestSummary?: {
        failedGreenlightRequestCount: number
        needsAttentionGreenlightRequestCount: number
        successGreenlightRequestCount: number
        // APP-34: enrolled + retrieval in flight (e.g. OM1_NEW). Optional so older payloads
        // without the field render unchanged.
        inProgressGreenlightRequestCount?: number
    }
}

const RequestStatusIcon: React.FC<RequestStatusIconProps> = ({ requestSummary }) => {
    if (!requestSummary) return null

    return (
        <div className='flex items-center gap-1' data-testid='request-status-container'>
            {requestSummary.failedGreenlightRequestCount > 0 && (
                <div title={`${requestSummary.failedGreenlightRequestCount} failed requests`}>
                    <XCircle className='text-red-500 w-4 h-4' />
                </div>
            )}

            {requestSummary.needsAttentionGreenlightRequestCount > 0 && (
                <div title={`${requestSummary.needsAttentionGreenlightRequestCount} requests need attention`}>
                    <AlertCircle className='text-yellow-500 w-4 h-4' />
                </div>
            )}

            {(requestSummary.inProgressGreenlightRequestCount ?? 0) > 0 && (
                <div title={`${requestSummary.inProgressGreenlightRequestCount} requests in progress`}>
                    <Clock className='text-blue-500 w-4 h-4' />
                </div>
            )}

            {requestSummary.successGreenlightRequestCount > 0 && (
                <div title={`${requestSummary.successGreenlightRequestCount} successful requests`}>
                    <CheckCircle className='text-green-500 w-4 h-4' />
                </div>
            )}
        </div>
    )
}

export default RequestStatusIcon
